var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "overview-item no-margin" }, [
    _c("div", { staticClass: "item-label bold-item" }, [
      _vm._v("\n    " + _vm._s(_vm.tc("booking.total")) + "\n  "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item-value" }, [
      _vm._v("\n    " + _vm._s(_vm.totalDisplay) + "\n  "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }